interface ITabSwitchComponentProps {
  orderType: "QC" | "TRANSFER" | "Rx";
  setOrderType: (value: "QC" | "TRANSFER" | "Rx") => void;
  showQcTransferOrdersTabs?: boolean;
  showRxOrdersTab?: boolean;
}

const tabs: Array<{ id: "QC" | "TRANSFER" | "Rx"; label: string; mobileLabel: string }> = [
  { id: "QC", label: "QC Orders", mobileLabel: "QC" },
  { id: "TRANSFER", label: "Transfer Orders", mobileLabel: "Transfer" },
  { id: "Rx", label: "Rx Orders", mobileLabel: "Rx" },
];

const TabSwitchComponent = ({
  orderType,
  setOrderType,
  showQcTransferOrdersTabs = true,
  showRxOrdersTab = true,
}: ITabSwitchComponentProps) => {
  const visibleTabs = tabs.filter((tab) => {
    if ((tab.id === "QC" || tab.id === "TRANSFER") && !showQcTransferOrdersTabs) return false;
    if (tab.id === "Rx" && !showRxOrdersTab) return false;
    return true;
  });
  const mobileGridColumnsClass =
    visibleTabs.length === 1 ? "grid-cols-1" : visibleTabs.length === 2 ? "grid-cols-2" : "grid-cols-3";

  return (
    <div className={`grid w-full items-center gap-2 rounded-xl ${mobileGridColumnsClass} sm:inline-flex sm:w-auto`}>
      {visibleTabs.map((tab) => {
        const isActive = orderType === tab.id;

        return (
          <button
            key={tab.id}
            type="button"
            onClick={() => setOrderType(tab.id)}
            title={tab.label}
            className={`group relative inline-flex min-w-0 items-center justify-center overflow-hidden rounded-lg text-xs font-semibold transition-all duration-200 sm:min-w-[130px] sm:text-sm ${
              isActive ? "border border-black" : "border border-[#E4E7EC] hover:border-black"
            }`}
          >
            <span
              className={`relative block w-full rounded-[7px] px-2 py-2 text-center text-[11px] leading-4 whitespace-nowrap transition-all duration-200 sm:px-4 sm:text-sm sm:leading-5 ${
                isActive ? "text-black" : "text-[#667085] group-hover:text-[#344054]"
              }`}
            >
              <span className="sm:hidden">{tab.mobileLabel}</span>
              <span className="hidden sm:inline">{tab.label}</span>
            </span>
          </button>
        );
      })}
    </div>
  );
};

export default TabSwitchComponent;
